export type CsvHeader<Value> = { title: string, parse: (value: string) => Value };

export function parseCsv<Row extends {}>(csvContent: string, headers: { [P in keyof Row]: CsvHeader<Row[P]> }): Array<Row> {
    const lines = csvContent.split(/\r?\n/).filter(line => line.trim());
    if (lines.length < 2) return [];

    const parseCsvLine = (line: string): string[] =>
        line.split(',').map(cell => cell.trim().replace(/^"|"$/g, ''));

    const headerRow = new Map<string, number>(
        parseCsvLine(lines[0]).map((headerText, columnIndex) => [headerText.toLowerCase(), columnIndex])
    );

    const missingHeaders = (Object.values(headers) as CsvHeader<any>[])
        .map(({title}) => title)
        .filter(title => !headerRow.has(title.toLowerCase()));


    if (missingHeaders.length > 0) {
        throw new Error(`CSV must have columns ${missingHeaders.join(', ')}`);
    }

    return lines
        .slice(1)
        .map(line => {
            const cols = parseCsvLine(line);

            return Object.fromEntries(
                (Object.entries(headers) as [string, CsvHeader<any>][])
                    .map(([propName, {title, parse}]) => {
                        const columnIndex = headerRow.get(title.toLowerCase()) ?? -1;
                        return [propName, parse(cols[columnIndex])];
                    })
            ) as Row;
        });
}